import React, { useContext } from 'react'
import { Outlet } from 'react-router-dom'
import { Redirect } from '@notino/react-toolkit/renderer/fragment/contexts/HttpContext'

// utils
import { useIntl } from 'react-intl'
import { AppContext } from '../utils/appProvider'
import Paths from './paths'
import { AvailableLanguages } from '../types/types'

const AuthRoute = () => {
	const { isAuthorized } = useContext(AppContext)
	const { locale } = useIntl() as { locale: AvailableLanguages }

	if (!isAuthorized) {
		return <Redirect to={Paths[locale]['/salons/all']} />
	}

	return <Outlet />
}

export default AuthRoute
